module.exports = __webpack_public_path__ + "img/icon-help-filled.cbe21460.svg";